/* NR transparent-header solidify-on-scroll.
   Focal drops its own scroll listener for transparent+sticky headers, so it only
   solidifies on hover. This re-adds it robustly: an IntersectionObserver on a top
   sentinel (primary) PLUS a scroll/resize fallback. Transparent while within ~28px
   of the top, solid once scrolled past. Both fire in real browsers. */
(function () {
  function init() {
    var header = document.querySelector('store-header[transparent]');
    if (!header) return;
    var threshold = 28;

    function setState(atTop) {
      if (atTop) {
        if (!header.matches(':hover')) header.classList.add('header--transparent');
      } else {
        header.classList.remove('header--transparent');
      }
    }

    if ('IntersectionObserver' in window) {
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      sentinel.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:' + threshold + 'px;pointer-events:none;visibility:hidden;';
      document.body.prepend(sentinel);
      new IntersectionObserver(function (entries) {
        setState(entries[0].isIntersecting);
      }, { threshold: 0 }).observe(sentinel);
    }

    function onScroll() { setState(window.scrollY <= threshold); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();
